const hasExplicitTimezone = (value: string): boolean => (
  value.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(value)
);

/** Older API records omit the timezone; their stored timestamps are still UTC. */
export const overviewTimestamp = (iso?: string | null): number => {
  const value = iso?.trim();

  return value ? Date.parse(hasExplicitTimezone(value) ? value : `${value}Z`) || 0 : 0;
};

/** Format overview timestamps in the viewer's local timezone, through seconds. */
export const formatOverviewDateTime = (iso: string): string => {
  const timestamp = overviewTimestamp(iso);

  if (!timestamp) return '';

  const date = new Date(timestamp);

  return date.toLocaleString([], {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};
